import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { normalizeProfileBookingRequestStatus } from 'app/main/pages/profile/profile-form/profile-form-bookings-tab/utils/profile-booking-request-status.utils';

@Pipe({
    name: 'getStatus',
})
@Injectable()
export class GetStatusPipe implements PipeTransform {
    transform(statusName: string, entityStatuses: any, property: string): string {
        if (!statusName) {
            return '';
        }

        const normalizedStatusName = normalizeProfileBookingRequestStatus(statusName) || statusName;
        const entityStatus = entityStatuses.all.filter((status) => status.name === normalizedStatusName)[0];

        if (!entityStatus) {
            return statusName;
        }

        return entityStatus[property];
    }
}
